/*
 * Copyright (c) 2016-2020 Martin Donath <martin.donath@squidfunk.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */

/* ----------------------------------------------------------------------------
 * Functions
 * ------------------------------------------------------------------------- */

/**
 * Set anchor blur
 *
 * @param el - Anchor element
 * @param value - Whether the anchor is blurred
 */
export function setAnchorBlur(
  el: HTMLElement, value: boolean
): void {
  el.setAttribute("data-md-state", value ? "blur" : "")
}

/**
 * Reset anchor blur
 *
 * @param el - Anchor element
 */
export function resetAnchorBlur(
  el: HTMLElement
): void {
  el.removeAttribute("data-md-state")
}

/* ------------------------------------------------------------------------- */

/**
 * Set anchor active
 *
 * @param el - Anchor element
 * @param value - Whether the anchor is active
 */
export function setAnchorActive(
  el: HTMLElement, value: boolean
): void {
  el.classList.toggle("md-nav__link--active", value)
}

/**
 * Reset anchor active
 *
 * @param el - Anchor element
 */
export function resetAnchorActive(
  el: HTMLElement
): void {
  el.classList.remove("md-nav__link--active")
}
